import { render, staticRenderFns } from "./gameFilterComponent.vue?vue&type=template&id=68c53b34&scoped=true&"
import script from "./gameFilterComponent.vue?vue&type=script&lang=js&"
export * from "./gameFilterComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c53b34",
  null
  
)

export default component.exports